module.exports = __webpack_public_path__ + "static/media/credits.22deff05.png";